export default __webpack_public_path__ + "static/media/foot-img.0ffa63ba.png";